/**
 * Determines the type of device based on the user agent string.
 *
 * This utility function is used to identify whether the current device is a mobile, tablet, or desktop device.
 * It provides support for both client-side and server-side detection by taking an optional user agent string.
 *
 * @param {string} [userAgent] - Optional user agent string for server-side detection. Defaults to `navigator.userAgent` in the browser.
 * @returns {DeviceTypes} - The detected device type: `Mobile`, `Tablet`, or `Desktop`.
 *
 * @example
 * // On the client-side:
 * const deviceType = getDeviceType();
 * console.log(deviceType); // Output: `Mobile`, `Tablet`, or `Desktop`
 *
 * @example
 * // On the server-side:
 * const deviceType = getDeviceType("Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X)");
 * console.log(deviceType); // Output: `Mobile`
 */
let deviceType = 'Unknown';
const getDeviceType = (userAgent) => {
    if (deviceType !== 'Unknown') {
        return deviceType;
    }
    let ua;
    if (typeof window !== 'undefined') {
        ua = navigator.userAgent;
    }
    else {
        ua = userAgent;
    }
    if (/Tablet|iPad/i.test(ua)) {
        deviceType = 'Tablet';
    }
    else if (/Mobi|Android/i.test(ua)) {
        deviceType = 'Mobile';
    }
    else if (/Intel Mac/i.test(ua) && navigator.maxTouchPoints > 0) {
        deviceType = 'Tablet';
    }
    else {
        deviceType = 'Desktop';
    }
    return deviceType;
};
let device;
if (typeof window !== 'undefined') {
    device = getDeviceType();
}
else {
    device = 'Unknown';
}
const isMobileDevice = device === 'Mobile';
const isTabletDevice = device === 'Tablet';
const isDesktopDevice = device === 'Desktop';

export { getDeviceType, isDesktopDevice, isMobileDevice, isTabletDevice };
